import { groupId, veluxType } from '~/helpers/fields-description';
import { VeluxModule } from '~/models/modules/velux/VeluxModule.model';

export class NXO extends VeluxModule {
    group_id?: number;
    velux_type?: string;

    get fieldGroupIp() {
        return groupId(this.group_id);
    }
    get fieldVeluxType() {
        return veluxType(this.velux_type);
    }
}
